import * as React from 'react';
import { useEffect, useState } from "react";
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import { getString } from "../../lang";
import "../../variables.css";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const AddBrokerDialog = ({ isVisible, onClose }) => {
    console.log("isVisible", isVisible, onClose);
    const [ open, setOpen ] = useState(false);

    const [ title, setTitle ] = useState("");
    const [ userList, setUserList ] = useState([]);
    const [ moduleList, setModuleList ] = useState([]);
    const [ clientsList, setClientsList ] = useState([]);
    const [ connectionType, setConnectionType ] = useState("");
    const [ clientType, setClientType ] = useState("");
    const [ brokerage, setBrokerage ] = useState("");
    const [ broker, setBroker ] = useState("");
    const [ ipAddress, setIpAddress ] = useState("");
    const [ domain, setDomain ] = useState("");
    const [ email, setEmail ] = useState("");
    const [ apiKey, setApiKey ] = useState("");
    const [ extraInfo, setExtraInfo] = useState("");
    const [ tradeInfo, setTradeInfo ] = useState("");

    const handleUserChange = (event) => {
        const { target: { value } } = event;
        setUserList(typeof value === 'string' ? value.split(',') : value);
    };

    const handleConnectionTypeChange = (event) => {
        setConnectionType(event.target.value);
    };

    const handleClientTypeChange = (event) => {
        setClientType(event.target.value);
    };
    
    const handleModuleChange = (event) => {
        const { target: { value } } = event;
        setModuleList(typeof value === 'string' ? value.split(',') : value);
    }

    const handleClientChange = (event) => {
        const { target: { value } } = event;
        setClientsList(typeof value === 'string' ? value.split(',') : value);
    };

    const users = [
        'Oliver Hansen',
        'Van Henry',
        'April Tucker',
        'Ralph Hubbard',
        'Omar Alexander',
        'Carlos Abbott',
        'Miriam Wagner',
        'Bradley Wilkerson',
        'Virginia Andrews',
        'Kelly Snyder',
    ];

    const modules = [
        'Trading API',
        'EQ Market Opinion',
        'Auth'
    ]

    const clients = [
        'Dhan',
        'Angelone',
        'Paytm Money'
    ]

    useEffect(() =>{
        setOpen(isVisible);
    }, [isVisible]);

    // const handleClickOpen = () => {
    //     setOpen(true);
    // };

    const handleClose = () => {
        setOpen(false);
        if (onClose) onClose();
    };

    return (
        <>
            <Dialog fullScreen open={open} onClose={handleClose} slots={{ transition: Transition }}>
                <AppBar sx={{ position: 'relative', backgroundColor: "var(--primary-theme-color)" }  }>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={ handleClose }
                            aria-label="close"
                        >
                        <CloseIcon />
                        </IconButton>
                        
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            { getString("add_broker") }
                        </Typography>
                        
                        <Button autoFocus color="inherit" onClick={ handleClose }>
                            { getString("save") }
                        </Button>
                    </Toolbar>
                </AppBar>

                <div className="px-4 py-4">
                    <Grid container spacing={2} columns={24} className="mb-4">
                        <Grid size={ { sx: 24, sm: 24, md: 12, lg: 12, xl: 12 } }>
                            
                            {/* Title */}
                            <div className="flex items-center gap-4 mb-4">
                                <div className="flex-1 text-[16px] font-semibold card-title-color">
                                    { getString("title") }
                                </div>

                                <div className="flex-[2]">
                                    <TextField
                                        id="outlined-size-small"
                                        size="small"
                                        value = { title }
                                        label = { getString("title") }
                                        onChange={(e) => setTitle(e.target.value)}
                                        fullWidth
                                    />
                                </div>
                            </div>
                            
                            {/* Broker */}
                            <div className="flex items-center gap-4 mb-4">
                                <div className="flex-1 text-[16px] font-semibold card-title-color">
                                    { getString("broker") }
                                </div>

                                <div className="flex-[2]">
                                    <TextField
                                        id="outlined-size-small"
                                        size="small"
                                        value = { broker }
                                        label = { getString("broker") }
                                        onChange={(e) => setBroker(e.target.value)}
                                        fullWidth
                                    />
                                </div>
                            </div>

                            {/* Users */}
                            <div className="flex items-center gap-4 mb-4">
                                <div className="flex-1 text-[16px] font-semibold card-title-color">
                                    { getString("users") }
                                </div>

                                <div className="flex-[2]">
                                    <FormControl size="small" fullWidth>
                                        <InputLabel id="demo-multiple-checkbox-label">{ getString("users") }</InputLabel>
                                        <Select
                                            labelId="demo-multiple-checkbox-label"
                                            id="demo-multiple-checkbox"
                                            label={ getString("users") }
                                            multiple
                                            value = { userList }
                                            onChange = { handleUserChange }
                                            renderValue= {(selected) => selected.join(',')}
                                            MenuProps = { MenuProps }
                                        >
                                        { users.map(( user ) => {
                                            const selected = userList.includes( user );
                                            const SelectionIcon = selected ? CheckBoxIcon : CheckBoxOutlineBlankIcon;

                                            return (
                                            <MenuItem key={ user } value={ user }>
                                                <SelectionIcon
                                                    fontSize = "small"
                                                    style = {{ marginRight: 8, padding: 9, boxSizing: 'content-box' }}
                                                />
                                                <ListItemText primary={ user } />
                                            </MenuItem>
                                            );
                                        })}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>

                            {/* IP Address */}
                            <div className="flex items-center gap-4 mb-4">
                                <div className="flex-1 text-[16px] font-semibold card-title-color">
                                    { getString("ip_address") }
                                </div>

                                <div className="flex-[2]">
                                    <TextField
                                        id="outlined-size-small"
                                        size="small"
                                        label={ getString("ip_address") }
                                        value = { ipAddress }
                                        onChange={(e) => setIpAddress(e.target.value)}
                                        fullWidth
                                    />
                                </div>
                            </div>
                            
                            {/* Domain */}
                            <div className="flex items-center gap-4 mb-4">
                                <div className="flex-1 text-[16px] font-semibold card-title-color">
                                    { getString("domain") }
                                </div>

                                <div className="flex-[2]">
                                    <TextField
                                        id="outlined-size-small"
                                        size="small"
                                        label={ getString("domain") }
                                        value = { domain }
                                        onChange={(e) => setDomain(e.target.value)}
                                        fullWidth
                                    />
                                </div>
                            </div>
                            
                            {/* Email */}
                            <div className="flex items-center gap-4 mb-4">
                                <div className="flex-1 text-[16px] font-semibold card-title-color">
                                    { getString("email") }
                                </div>

                                <div className="flex-[2]">
                                    <TextField
                                        id="outlined-size-small"
                                        size="small"
                                        label={ getString("email") }
                                        value = { email }
                                        onChange={(e) => setEmail(e.target.value)}
                                        fullWidth
                                    />
                                </div>
                            </div>
                            
                            {/* API Key */}
                            <div className="flex items-center gap-4 mb-4">
                                <div className="flex-1 text-[16px] font-semibold card-title-color">
                                    { getString("api_key") }
                                </div>

                                <div className="flex-[2]">
                                    <TextField
                                        id="outlined-size-small"
                                        size="small"
                                        label={ getString("api_key") }
                                        value = { apiKey }
                                        onChange={ (e) => setApiKey(e.target.value) }
                                        fullWidth
                                    />
                                </div>
                            </div>
                            
                            {/* Connection Type */}
                            <div className="flex items-center gap-4 mb-4">
                                <div className="flex-1 text-[16px] font-semibold card-title-color">
                                    { getString("connection_type") }
                                </div>

                                <div className="flex-[2]">
                                    <FormControl size="small" fullWidth>
                                        <InputLabel id="demo-simple-select-label">{ getString("connection_type") }</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label={ getString("connection_type") }
                                            value={ connectionType }
                                            onChange={ handleConnectionTypeChange }
                                        >
                                            <MenuItem value={1}>Front End</MenuItem>
                                            <MenuItem value={2}>Back End</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                            
                            {/* Client Type */}
                            <div className="flex items-center gap-4 mb-4">
                                <div className="flex-1 text-[16px] font-semibold card-title-color">
                                    { getString("client_type") }
                                </div>

                                <div className="flex-[2]">
                                    <FormControl size="small" fullWidth>
                                        <InputLabel id="demo-simple-select-label-2">{ getString("client_type") }</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label-2"
                                            id="demo-simple-select-2"
                                            label={ getString("client_type") }
                                            value={ clientType }
                                            onChange={ handleClientTypeChange }
                                        >
                                            <MenuItem value={1}>User Paying</MenuItem>
                                            <MenuItem value={2}>Client Paying</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                            
                            {/* Modules */}
                            <div className="flex items-center gap-4 mb-4">
                                <div className="flex-1 text-[16px] font-semibold card-title-color">
                                    { getString("modules") }
                                </div>

                                <div className="flex-[2]">
                                    <FormControl size="small" fullWidth>
                                        <InputLabel id="demo-multiple-checkbox-label-modules">{ getString("modules") }</InputLabel>
                                        <Select
                                            labelId="demo-multiple-checkbox-label-modules"
                                            id="demo-multiple-checkbox-modules"
                                            multiple
                                            label={ getString("modules") }
                                            value={ moduleList }
                                            onChange={ handleModuleChange }
                                            renderValue={(selected) => selected.join(',')}
                                            MenuProps={ MenuProps }
                                        >
                                        { modules.map(( module ) => {
                                            const selected = moduleList.includes( module );
                                            const SelectionIcon = selected ? CheckBoxIcon : CheckBoxOutlineBlankIcon;

                                            return (
                                            <MenuItem key={ module } value={ module }>
                                                <SelectionIcon
                                                    fontSize="small"
                                                    style={{ marginRight: 8, padding: 9, boxSizing: 'content-box' }}
                                                />
                                                <ListItemText primary={ module } />
                                            </MenuItem>
                                            );
                                        })}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>

                            {/* Brokerage */}
                            <div className="flex items-center gap-4 mb-4">
                                <div className="flex-1 text-[16px] font-semibold card-title-color">
                                    { getString("brokerage") }
                                </div>

                                <div className="flex-[2]">
                                    <TextField
                                        id="outlined-multiline-flexible"
                                        label={ getString("brokerage") }
                                        multiline
                                        maxRows={4}
                                        size="small"
                                        value = { brokerage }
                                        onChange={ (e) => setBrokerage(e.target.value) }
                                        fullWidth
                                    />
                                </div>
                            </div>

                            {/* Connected Clients */}
                            <div className="flex items-center gap-4 mb-4">
                                <div className="flex-1 text-[16px] font-semibold card-title-color">
                                    { getString("connected_clients") }
                                </div>

                                <div className="flex-[2]">
                                    <FormControl size="small" fullWidth>
                                        <InputLabel id="demo-multiple-checkbox-label-clients">{ getString("connected_clients") }</InputLabel>
                                        <Select
                                            labelId="demo-multiple-checkbox-label-clients"
                                            id="demo-multiple-checkbox-clients"
                                            label={ getString("connected_clients") }
                                            multiple
                                            value={ clientsList }
                                            onChange={ handleClientChange }
                                            renderValue={(selected) => selected.join(',')}
                                            MenuProps={ MenuProps }
                                        >
                                        { clients.map(( client ) => {
                                            const selected = clientsList.includes( client );
                                            const SelectionIcon = selected ? CheckBoxIcon : CheckBoxOutlineBlankIcon;

                                            return (
                                            <MenuItem key={ client } value={ client }>
                                                <SelectionIcon
                                                    fontSize="small"
                                                    style={{ marginRight: 8, padding: 9, boxSizing: 'content-box' }}
                                                />
                                                <ListItemText primary={ client } />
                                            </MenuItem>
                                            );
                                        })}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>

                            {/* Extra Info */}
                            <div className="flex items-center gap-4 mb-4">
                                <div className="flex-1 text-[16px] font-semibold card-title-color">
                                    { getString("extra_info") }
                                </div>

                                <div className="flex-[2]">
                                    <TextField
                                        id="outlined-multiline-flexible"
                                        label={ getString("extra_info") }
                                        multiline
                                        rows={4}
                                        size="small"
                                        value = { extraInfo }
                                        onChange={ (e) => setExtraInfo(e.target.value) }
                                        fullWidth
                                    />
                                </div>
                            </div>
                            
                            {/* Trade Info */}
                            <div className="flex items-center gap-4 mb-4">
                                <div className="flex-1 text-[16px] font-semibold card-title-color">
                                    { getString("trade_info") }
                                </div>

                                <div className="flex-[2]">
                                    <TextField
                                        id="outlined-multiline-flexible"
                                        label={ getString("trade_info") }
                                        multiline
                                        rows={4}
                                        size="small"
                                        value = { tradeInfo }
                                        onChange={ (e) => setTradeInfo(e.target.value) }
                                        fullWidth
                                    />
                                </div>
                            </div>
                        </Grid>
                    </Grid>

                </div>
            </Dialog>
        </>
    )
}

export default AddBrokerDialog;